module.exports = __webpack_public_path__ + "img/Gerätewagen_Atemschutz.a510a985.svg";